import Dictionary from "~/ts/library/Dictionary";
import {ref} from "vue";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {
    OPERATOR_APPLICATION_DIALOGS_ROUTE_LIST_ID_MAIN
} from "~/operatorApplication/ts/router/OperatorApplicationRouteNames";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";


class OperatorApplicationDialogs {
    selectedUsernames = ref<Dictionary<string>>({});

    setSelectedUsername(payload: { buddyListId: string, username: string }) {
        this.selectedUsernames.value[payload.buddyListId] = payload.username;
        if (payload.username) {
            ClientUserdataStore.readMessages({username: payload.username});
        }
    }

    getSelectedUsername(buddyListId: string) {
        if (!this.selectedUsernames.value.hasOwnProperty(buddyListId)) {
            this.setSelectedUsername({buddyListId, username: null});
        }
        let result = this.selectedUsernames.value[buddyListId];
        if (result) {
            if (buddyListId == OPERATOR_APPLICATION_DIALOGS_ROUTE_LIST_ID_MAIN) {
                if (!OperatorAccountStore.buddyList.value.includes(result) && !OperatorAccountStore.crossOperatorChat.value[result]) {
                    result = null;
                }
            }
        }
        return result;
    }

    reset() {
        this.selectedUsernames.value = {};
    }

}


export const OperatorApplicationDialogsStore = new OperatorApplicationDialogs();


